<template>
  <div class="modal-window alert ab032">
    <header class="modal-header" style="height:31px;">
      <div class="tit">{{ modalInfo.title }}</div>
      <button @click="$emit('close')" class="btn_close">닫기</button>
    </header>

    <div class="modal-content">
      <div class="info-txt small">{{ modalInfo.contents }}</div>
    </div>

    <footer class="modal-footer">
      <button type="button" class="btn_ty1" @click="$emit('close')">{{ $i18nUtil.trans("button.confirm","확인") }}</button>
    </footer>
  </div>
</template>

<script>
export default {
  props: {
    modalInfo: {
      type: Object,
      required: true
    }
  },
  components: {},
    data() {
      return {};
    },
  methods: {},
}
</script>


// WEBPACK FOOTER //
// src/components/cowork/general/file/modal/ViewerNoticeModal.vue